import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTuvalu = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1377)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M24 12C24 18.6274 18.6274 24 12 24C5.37263 24 0 18.6274 0 12C0 12.0029 12 0.0013125 12 0C18.6274 0 24 5.37262 24 12Z",
				fill: "#338AF3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.73914 12H9.78642L6.26085 7.82611L5.73914 9.39131V12Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 9.78646L7.82605 5.73914H11.9999L12 9.78646Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9679 12H12C12 11.9892 12 11.9787 12 11.9679C11.9893 11.9786 11.9786 11.9893 11.9679 12Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 6.26086C12 4.14937 12 2.76581 12 0H11.998C5.3715 0.001125 0 5.37323 0 12H6.26091V8.47448L9.78642 12H11.968C11.9787 11.9893 11.9894 11.9786 12.0001 11.9679C12.0001 11.1594 12.0001 10.4381 12.0001 9.78647L8.47444 6.26086H12Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.071 1.56522C4.19417 2.63392 2.63389 4.1942 1.56519 6.07103V12H4.69564V4.69576V4.69567H12C12 3.70834 12 2.76775 12 1.56522H6.071Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 10.5243L7.73649 6.26093H6.26086V6.26102L11.9999 12H12C12 12 12 10.9825 12 10.5243Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.0972 19.8261L13.3562 20.6233H14.1944L13.5163 21.1159L13.7753 21.913L13.0972 21.4204L12.4191 21.913L12.6781 21.1159L12 20.6233H12.8381L13.0972 19.8261Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.7724 14.6087L20.0314 15.4058H20.8695L20.1915 15.8985L20.4506 16.6956L19.7724 16.203L19.0943 16.6956L19.3534 15.8985L18.6752 15.4058H19.5133L19.7724 14.6087Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.4449 6.78262L21.704 7.57978H22.5421L21.8641 8.07244L22.1231 8.86954L21.4449 8.37694L20.7669 8.86954L21.0259 8.07244L20.3478 7.57978H21.1859L21.4449 6.78262Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.8594 12.5217L22.1184 13.3189H22.9566L22.2785 13.8116L22.5376 14.6087L21.8594 14.1161L21.1814 14.6087L21.4404 13.8116L20.7622 13.3189H21.6004L21.8594 12.5217Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.299 17.9512L15.0459 18.3318L15.6386 17.7391L15.5075 18.5669L16.2543 18.9474L15.4264 19.0786L15.2953 19.9064L14.9148 19.1596L14.0869 19.2908L14.6796 18.6982L14.299 17.9512Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.299 14.8208L15.0459 15.2013L15.6386 14.6087L15.5075 15.4365L16.2543 15.817L15.4264 15.9481L15.2953 16.776L14.9148 16.0292L14.0869 16.1603L14.6796 15.5677L14.299 14.8208Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.9077 16.8274L17.6547 17.2079L18.2473 16.6153L18.1163 17.4431L18.863 17.8236L18.0351 17.9547L17.904 18.7826L17.5236 18.0357L16.6957 18.167L17.2883 17.5743L16.9077 16.8274Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.9077 10.1251L17.6547 10.5057L18.2473 9.91302L18.1163 10.7408L18.863 11.1213L18.0351 11.2525L17.904 12.0803L17.5236 11.3335L16.6957 11.4647L17.2883 10.872L16.9077 10.1251Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.4361 10.0448L20.183 10.4253L20.7757 9.83267L20.6445 10.6605L21.3914 11.041L20.5635 11.1721L20.4323 12L20.0519 11.2532L19.224 11.3843L19.8166 10.7917L19.4361 10.0448Z",
				fill: "#FFDA44"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1377",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgTuvalu;
